import React, { Component } from "react"
import { ModalContainer, ModalDialog } from "react-modal-dialog"
import PendenciaForm from "./PendenciaForm"
import { HttpError } from "../../components"
import * as ApiHelper from "../../ApiHelper"
export default class PendenciasModal extends Component {
  constructor() {
    super()
    this.callBackPendencias = this.callBackPendencias.bind(this)
    this.state = { isShowingModal: false }
  }
  getUnidades() {
    ApiHelper.getSolicitacoesPendenciasEdit(
      this.props.pendenciaId,
      (item, error) => {
        if (item) {
          this.props.callBack(item)
        } else {
          this.setState({
            httpError: error
          })
        }
      }
    )
  }
  callBackPendencias() {
    this.getUnidades()
  }
  render() {
    if (this.state.httpError) {
      return (
        <div onClick={this.props.onClose}>
          {this.props.show && (
            <ModalContainer onClose={this.props.onClose}>
              <ModalDialog
                style={{ width: "70%" }}
                onClose={this.props.onClose}
              >
                <HttpError
                  message={this.state.httpError.message}
                  status={this.state.httpError.status}
                />
              </ModalDialog>
            </ModalContainer>
          )}
        </div>
      )
    }
    return (
      <div onClick={this.props.onClose}>
        {this.props.show && (
          <ModalContainer onClose={this.props.onClose}>
            <ModalDialog style={{ width: "70%" }} onClose={this.props.onClose}>
              <PendenciaForm
                pendenciaId={this.props.pendenciaId}
                callBackPendencias={this.callBackPendencias}
              />
            </ModalDialog>
          </ModalContainer>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/modais/PendenciasModal.js